import axios from "axios";

axios.defaults.baseURL = `/welcome/api/`;

export const query = axios;
